import fetch from 'node-fetch';
import { BusinessModel } from '../../interfaces/BusinessModel.interface';
import rollbar from './rollbar';

const linkSocials = async (business: BusinessModel, redirectUrl: string): Promise<{ url: string }> => {
  const path = `${process.env.NEXT_PUBLIC_ADMIN_API_URL}/businesses/social/profile/ayrshare/fromReservedIdToken?fields=url`;
  // @ts-ignore WRONG!
  const headers = new fetch.Headers({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Api-Version': '1.0.10',
    'X-Sdk-Name': 'partner-intake',
    'X-Sdk-Version': '4.91.1',
  });
  const body = {
    token: business.token,
    redirect: redirectUrl,
  };

  const response = await fetch(
    path,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    },
  );

  const json = await response.json();

  if (!response.ok) {
    const e = new Error(`${response.status} ${response.statusText}`);
    // @ts-ignore WRONG!
    e.response = response;
    // @ts-ignore I think you'll find `cause` _does_ exist on Error
    e.cause = json;
    rollbar.error(e);
    throw e;
  }

  return json.payload;
};

export default linkSocials;
